function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.508 10.181H.492A.492.492 0 010 9.689V6.705A1.147 1.147 0 011.148 5.59h17.858A.931.931 0 0120 6.601v3.09a.492.492 0 01-.492.49zM.983 9.197h18.033v-2.6-.028H1.148c-.08 0-.164.068-.164.131z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.165 19.689a1.182 1.182 0 01-1.181-1.151V9.689a.492.492 0 01.492-.492h17.049a.492.492 0 01.492.492v8.843a1.087 1.087 0 01-1.068 1.15zm-.2-9.508v8.357a.2.2 0 00.2.167l15.784-.008c.078 0 .085-.128.085-.167v-8.351z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 19.689a.492.492 0 01-.492-.492V5.891a.492.492 0 01.984 0v13.307a.492.492 0 01-.492.491z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.152 6.574a.492.492 0 01-.44-.712C11.968 1.351 14.383 1 15.07 1a3.175 3.175 0 011.452.257 1.91 1.91 0 011.007 1.874c0 2.133-2.2 3.443-3.77 3.443a.492.492 0 110-.984c.972 0 2.787-.845 2.787-2.459 0-.683-.265-.895-.465-1a2.352 2.352 0 00-.995-.152c-.4 0-2.439.208-4.494 4.318a.493.493 0 01-.44.277z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.153 6.574a.492.492 0 01-.44-.272c-2.055-4.11-4.091-4.318-4.478-4.318a2.365 2.365 0 00-1.011.152c-.2.1-.465.312-.465 1 0 1.614 1.814 2.459 2.787 2.459a.492.492 0 010 .984c-1.574 0-3.77-1.31-3.77-3.443a1.909 1.909 0 011.007-1.874 3.138 3.138 0 011.436-.257c.7 0 3.118.35 5.374 4.862a.492.492 0 01-.44.712z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
});

var SvgGiftOptions = function SvgGiftOptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgGiftOptions, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/GiftOptions.ad9af64d.svg";
export { ForwardRef as ReactComponent };